import axiosClient from "../axios-client";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";

export const getUserOverview = async (data) => {
  let url = "/ai-astrologer/overview";
  if (Object.keys(data).length > 0) {
    url = url + `?start_date=${data?.start_date}&end_date=${data.end_date}`;
  }
  return axiosClient
    .get(url)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      toastMessage("Error fetching overview for selected day period", "error");
      return error;
    });
};

export const getSelectedUserDetails = async (user_id) => {
  return axiosClient
    .get(`/ai-astrologer/user/${user_id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      toastMessage("AI user data not found", "error");
      return error;
    });
};

export const getAiUserMessageHistory = async (dispatch, user_id) => {
  changeLoaderStatus(dispatch, true);
  return axiosClient
    .get(`/ai-astrologer/users/${user_id}/messages`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      toastMessage("AI user message history not found", "error");
      return error;
    })
    .finally(() => {
      setTimeout(() => {
        changeLoaderStatus(dispatch, false);
      }, 500);
    });
};

export const getAiUserTransactionHistory = async (dispatch, user_id) => {
  changeLoaderStatus(dispatch, true);
  return axiosClient
    .get(`/ai-astrologer/users/${user_id}/transactions`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      toastMessage("AI user message transactions not found", "error");
      return error;
    })
    .finally(() => {
      setTimeout(() => {
        changeLoaderStatus(dispatch, false);
      }, 500);
    });
};

/**
 * Daily flow/credit series plus totals summed from that same series.
 * The overview tiles and the trend chart both read this one response, per the handoff's
 * requirement that the KPI numbers and the chart cannot disagree.
 */
export const getAiMetrics = async ({ start_date, end_date, bucket } = {}) => {
  const qs = new URLSearchParams();
  if (start_date) qs.set("start_date", start_date);
  if (end_date) qs.set("end_date", end_date);
  // day | week | month. A year of daily bars is unreadable, so long windows group.
  if (bucket) qs.set("bucket", bucket);
  const suffix = qs.toString() ? `?${qs}` : "";

  return axiosClient
    .get(`/ai-astrologer/metrics${suffix}`)
    .then((res) => res.data)
    .catch((error) => {
      toastMessage("AI metrics could not be loaded", "error");
      throw error;
    });
};

/**
 * AI users on the shared list contract: passes every param through and returns
 * { items, total, page, limit }. The previous action forwarded only the dates,
 * silently dropping page and limit, so the pager showed the right number of
 * pages while every page rendered the whole set.
 */
export const listAiUsers = async (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === null || v === undefined || v === "") return;
    // Column filters arrive as an array and have to repeat the key. `set` would keep
    // only the last one, so filtering on two columns would silently drop the first.
    if (Array.isArray(v)) {
      v.forEach((item) => {
        if (item !== null && item !== undefined && item !== "") qs.append(k, item);
      });
      return;
    }
    qs.set(k, v);
  });
  return axiosClient
    .get(`/ai-astrologer/v3/users?${qs}`)
    .then((res) => res?.data)
    .catch((error) => {
      toastMessage("AI user data not found", "error");
      throw error;
    });
};

export const getAiUserCounts = async () =>
  axiosClient
    .get(`/ai-astrologer/v3/users/counts`)
    .then((res) => res?.data || {})
    .catch(() => ({}));
